import { visibleLanes } from '../auts/autLanes';

// Which AUT lane columns a branch's nightly table shows, and how wide they are.
//
// The EKS/RDS lanes ('*_v2') are deprecated — nightlies only start kind lanes now. Runs from
// before the switch still carry their EKS results, so a retired lane keeps its column for as
// long as a listed run has something to put in it, then disappears on its own.
const ALL_LANES = [
  { key: 'aut_mysql_v2',   label: 'MySQL AUT V2',   retired: true },
  { key: 'aut_psql_v2',    label: 'PgSQL AUT V2',   retired: true },
  { key: 'aut_mysql_kind', label: 'MySQL AUT kind' },
  { key: 'aut_psql_kind',  label: 'PgSQL AUT kind' },
];

// Columns that are always present, in percent. The AUT lanes share whatever is left.
const FIXED_COLUMNS = {
  leading: [
    { label: 'Run',    width: 10 },
    { label: 'Status', width: 11 },
  ],
  trailing: [
    { label: 'POV Rollout',  width: 12 },
    { label: 'Triggered by', width: 9  },
    { label: 'When',         width: 6  },
  ],
};

// A nightly keeps its lane results one level down, under result.
export function visibleAutLanes(runs = []) {
  return visibleLanes(ALL_LANES, runs.map((run) => run?.result));
}

// Widths must sum to 100%, so the lane columns are derived rather than hardcoded.
export function nightlyColumns(runs = []) {
  const lanes = visibleAutLanes(runs);
  const fixed = [...FIXED_COLUMNS.leading, ...FIXED_COLUMNS.trailing]
    .reduce((total, { width }) => total + width, 0);
  const laneWidth = `${(100 - fixed) / lanes.length}%`;

  return [
    ...FIXED_COLUMNS.leading.map(({ label, width }) => ({ label, width: `${width}%` })),
    ...lanes.map(({ label }) => ({ label, width: laneWidth })),
    ...FIXED_COLUMNS.trailing.map(({ label, width }) => ({ label, width: `${width}%` })),
  ];
}
